'use client';

import { Content, DialogTitle } from '@radix-ui/react-dialog';
import { ComponentPropsWithoutRef, ComponentRef, forwardRef } from 'react';

import cn from '@/helpers/cn';

import DialogOverlay from './DialogOverlay';
import DialogPortal from './DialogPortal';
import css from './style.module.scss';

type DialogContentProps = ComponentPropsWithoutRef<typeof Content> & {
	noOverlay?: boolean;
};

const DialogContent = forwardRef<ComponentRef<typeof Content>, DialogContentProps>(
	({ className, children, noOverlay, ...props }, ref) => (
		<DialogPortal>
			<DialogOverlay className={noOverlay ? css.overlayTransparent : undefined}>
				<Content ref={ref} className={cn(css.dialogContent, className ?? '')} {...props}>
					<DialogTitle className={css.visuallyHidden}>Modal Title</DialogTitle>
					{children}
				</Content>
			</DialogOverlay>
		</DialogPortal>
	)
);

export default DialogContent;
